import _ from 'lodash';
import { DEFAULT_INVALID_VALUE } from './FormattingUtilities';

export function middleEllipsis(str, maxLength = 65) {
    if (str && str.length > maxLength) {
        const half = _.divide(_.subtract(str.length, maxLength), 2);

        return `${str.substr(0, _.subtract(_.divide(str.length, 2), half)).trim()}...${str
            .substr(_.add(_.divide(str.length, 2), half), str.length)
            .trim()}`;
    }

    return str;
}

export function kabobToPascalCase(str) {
    if (!str) return str;
    const terms = str.split('-');
    return terms.map(_.capitalize).join('');
}

export function splitEmailString(emailString) {
    if (_.isEmpty(emailString)) {
        return [];
    }

    return _.reject(emailString.split(/[;, ]/), _.isEmpty);
}

export function formatTags(tags) {
    return _.isArray(tags) && tags.length > 0 ? tags.join(', ') : DEFAULT_INVALID_VALUE;
}

export default {
    kabobToPascalCase,
    middleEllipsis,
};
